import { Navigate } from 'react-router';

import { useSoftwareEscrow } from 'src/context/software-escrow';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';
import { NotificationsContextProvider } from 'src/context/suggest-changes';
import {
  SoftwareOnboardingFooter as Footer,
  SoftwareOnboardingLayout as Layout,
} from 'src/components/SoftwareOnboarding';
import { getRequestChangesExitPath } from 'src/pages/SoftwareEscrowRequestChanges/lib';
import { SoftwareEscrowRequestChangesRoutesEnum } from 'src/pages/SoftwareEscrowRequestChanges/model';

import { DepositorCreator } from './Depositor';
import { BeneficiaryCreator } from './Beneficiary';
import { SubmitChangesDialog, Header } from './ui';

const Content = () => {
  const {
    softwareEscrow: { currentCompanyRole },
  } = useSoftwareEscrow();

  const Main = currentCompanyRole === EscrowPartyTypeEnum.Depositor ? DepositorCreator : BeneficiaryCreator;

  return (
    <Layout>
      <Header />
      <Main />
      <Footer justify="end">
        <SubmitChangesDialog />
      </Footer>
    </Layout>
  );
};

const SoftwareEscrowRequestChangesTechnical = () => {
  const {
    softwareEscrow: { id, policy },
  } = useSoftwareEscrow();

  if (!policy.createNotificationSuggestedChange)
    return <Navigate to={getRequestChangesExitPath(id, SoftwareEscrowRequestChangesRoutesEnum.Technical)} replace />;

  return (
    <NotificationsContextProvider>
      <Content />
    </NotificationsContextProvider>
  );
};

export default SoftwareEscrowRequestChangesTechnical;
